import React, { useEffect, useState } from 'react';
import {Doughnut, Line} from 'react-chartjs-2';
import {API_URL} from "./App";

import {
  ArcElement,
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  ArcElement,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend
);

const BarChart = () => {
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [chartData, setChartData] = useState(null);

  // Load dates
  useEffect(() => {
    fetch(API_URL + "/statistics/available-dates")
      .then(res => res.json())
      .then(data => {
        setDates(data);
        setSelectedDate(data[0]); // default to most recent
      });
  }, []);

  useEffect(() => {
    fetch(API_URL + `/statistics/duration-data?date=${selectedDate}`)
      .then((res) => res.json())
      .then((data) => {
        setChartData({
          labels: data.labels,
          datasets: data.datasets
        });
      });
  }, [selectedDate]);

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Zeit pro Spiel',
        font: {
          size: 20,
          weight: 'bold',
        },
      },
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 20,
            weight: 'bold',
          },
        },
      },

    },

  };

  return chartData ?
    <div> <h2>Durchschnittliche Spielzeit pro Spiel</h2>
      <label htmlFor="date">Filterdatum: </label>
      <select id="date" value={selectedDate} onChange={e => setSelectedDate(e.target.value)}>
        {dates.map(date => (
          <option key={date} value={date}>{date}</option>
        ))}
          <option value="" >Alle Daten</option>
      </select> <div class={"Doughnut"} > <Doughnut data={chartData} options={options} /> </div></div>
     : <p>Loading chart...</p>;
};

export default BarChart;